import moment from 'moment'
/**
 * 
 */
//  const groundSellerName = ( sl_ground_seller_total, sl_ground_seller_curr ) => [
//   sl_ground_seller_curr.hr_employee.names,
//   sl_ground_seller_curr.hr_employee.last_name1,
// ].join( ' ' )

//
export default [
  // {
  //     text    : 'id',
  //     value   : 'id',
  // },
  {
      text    : 'N° serie',
      value   : 'serial_number',
  },
  {
      text    : 'Banco',
      value   : ({ g_bank }) => g_bank.bank,
  },
  {
      text    : 'Monto',
      value   : 'amount',
      format  : 'currency',
  },
  {
      text    : 'N° Documento',
      value   : 'account_number',
  },
  {
      text    : 'Fecha Emisión',
      align   : 'center',
      value   : ({ emission_date }) => moment(emission_date).format('DD/MM/YYYY'),
  },
  {
    text    : 'Fecha Cobro',
    align   : 'center',
    value   : ({ charge_date }) => (charge_date) ? moment(charge_date).format('DD/MM/YYYY') : '',
  },
  {
    text    : 'Estado',
    value : ({sl_check_status}) => (sl_check_status) ? sl_check_status.status : 'Pendiente',
    component: {
      type: "chip",
      props: {
          disabled: true,
          label: true,
          small: true,
          textColor: "black",
      },
    }
  }

  // {
  //     text    : 'Monto',
  //     format  : 'currency',
  //     align   : 'center',
  //     value   : 'balance',
  // },
]
